import { FlexContainer } from '@/ui/styled-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledText = styled.div`
  line-height: var(--small-line-height);
  font-size: var(--small-font-size);

  > span {
    color: #505050;
  }
`;

const Separator = styled.div`
  width: 1px;
  height: 15px;
  background-color: var(--gray-dark);
`;

export const UsersCountSubheader = ({
  allUsersCount,
  filteredUsersCount,
}: {
  allUsersCount: number;
  filteredUsersCount: number;
}) => {
  const { t } = useTranslation();

  return (
    <FlexContainer justify="flex-start" className="mb-4" gap={16}>
      <StyledText>
        <span>{t('users.count')}:</span> {allUsersCount}
      </StyledText>
      {allUsersCount !== filteredUsersCount && (
        <>
          <Separator />
          <StyledText>
            <span>{t('users.filtered.count')}:</span> {filteredUsersCount}
          </StyledText>
        </>
      )}
    </FlexContainer>
  );
};
